import { apiClient } from '../../../shared/utils/apiClient';
import type { ProfileNote } from '../../../shared/types/domainModels';

// /profile_notes.json answers an expired session with devise's {error} JSON
// and an outage with an HTML error page. Either one, fed straight into state,
// crashed the applicant list on notes.filter (Sentry DIRECTDENTAL-23V, -2A6).
// Only a real array reaches the callback; otherwise the current notes stay.
export const fetchProfileNotes = ({ callback }: { callback: (notes: ProfileNote[]) => void }) => {
  apiClient.get<ProfileNote[]>('/profile_notes.json')
    .then(res => {
      if (res.ok && Array.isArray(res.data)) callback(res.data);
    })
    .catch(() => {});
};
